import React from 'react';
import { SoilProfileStateClear } from '@/resource/IconComponentSets';

interface IProps {
  selectedStateCount: number,
  showStateCallback: () => void,
  clearTheSelectedStateCallback: () => void,
}

export default function TableHeaderLocationCell(props: IProps) {

    const {
        showStateCallback,
        selectedStateCount,
        clearTheSelectedStateCallback,
    } = props;

    return (
        <div onClick={() => showStateCallback && showStateCallback()}>
            <span>Location</span>
            <span
                className={'location-title'}
                hidden={!selectedStateCount}
            >
                <a className='state-count'>({selectedStateCount})</a>
                <span onClick={() =>
                    clearTheSelectedStateCallback && clearTheSelectedStateCallback()}
                >
                    <SoilProfileStateClear />
                </span>
            </span>
        </div>
    );
}